import React, { ReactNode } from 'react';
import classNames from 'classnames';
import config from 'config';

import appLogoSports from 'assets/images/CBS_sports_logo.png';
import appLogoNews from 'assets/images/CBS_news_logo.png';

import styles from './LogoPage.module.scss';

interface LogoPageProps {
  background?: 'transparent' | 'gradient' | 'opaque';
  children?: ReactNode;
  className?: string | null;
  hideLogo?: boolean;
}

const LogoPage = ({
  className = null,
  background = 'gradient',
  hideLogo = false,
  children = null,
}: LogoPageProps) => {
  return (
    <div
      className={classNames(
        'w-100 h-100',
        styles.page,
        {
          [styles.gradient]: background === 'gradient',
          [styles.opaque]: background === 'opaque',
        },
        className,
      )}
    >
      <img
        alt="App Logo"
        src={config.buildBrandId === 'cbs-news' ? appLogoNews : appLogoSports}
        className={classNames(styles.logo, {
          'd-block': !hideLogo,
          'd-none': hideLogo,
        })}
      />
      {children}
    </div>
  );
};

export default LogoPage;
